import { Building, ChevronRight, Mail, User } from 'lucide-react';

import { Flex } from '@/components/base';
import TooltipV2 from '@/components/Tooltip/TooltipV2';
import { toast } from '@/stores/pure/ToastStore';
import { clipboardCopy } from '@/utils/util';

import { EllipsisValue } from '../EllipsisValue';
import { ValueWrapper } from '../ValueWrapper';
import { PropertyRowWrapper } from './PropertyRowWrapper';
import type { CommonFieldProps } from './types';

export const CustomerField = (
  props: CommonFieldProps & {
    compnayName?: string;
    customerName?: string;
    customerEmail?: string;
  },
) => {
  const isCustomerInfo = props.customerName;
  const isCompanyInfo = props.compnayName;
  const isCustomerEmail = props.customerEmail;

  const allEmpty = !props.compnayName && !props.customerName;
  const hasAll = !!props.compnayName && !!props.customerName;

  if (!props.showFull && allEmpty) return null;

  return (
    <>
      <PropertyRowWrapper {...props} expandable>
        <Flex f={1} w="wrap" a="center">
          {isCompanyInfo && (
            <>
              <TooltipV2 tooltipNode={props.customerName}>
                <ValueWrapper>
                  <Building size={14} className="text-gray-600" />
                  <EllipsisValue>{props.compnayName}</EllipsisValue>
                </ValueWrapper>
              </TooltipV2>
            </>
          )}

          {hasAll && <ChevronRight className="size-3.5 text-gray-500" />}

          {isCustomerInfo && (
            <>
              <TooltipV2 tooltipNode={props.customerName}>
                <ValueWrapper>
                  <User size={14} className="text-gray-600" />
                  <EllipsisValue>{props.customerName}</EllipsisValue>
                </ValueWrapper>
              </TooltipV2>

              {isCustomerEmail && (
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    clipboardCopy(props.customerEmail || '');
                    toast('Email address copied', 'success');
                  }}
                  className="cursor-pointer"
                >
                  <TooltipV2 tooltipNode={props.customerEmail}>
                    <ValueWrapper>
                      <Mail size={12} className="text-gray-600" />
                    </ValueWrapper>
                  </TooltipV2>
                </div>
              )}
            </>
          )}
        </Flex>
      </PropertyRowWrapper>
    </>
  );
};
